// extracted by mini-css-extract-plugin
module.exports = {"body":"SymphonyWelcomeModal_body__PhdO8","benefits":"SymphonyWelcomeModal_benefits__WMQGu"};